import React from 'react';
import {ShowGuesser} from "@api-platform/admin";

const AirlineInfoShow = (props) => (
        <ShowGuesser {...props} resource="covid19-airline-infos"/>
);

export default AirlineInfoShow;
